import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material'
import React from 'react'
import { DocumentFilePreview } from 'components/documents'
import { NivosFile } from 'types/nivos-file'

interface AppProps {
  file: NivosFile
}

const DocumentCard: React.FC<AppProps> = props => {
  const { file } = props
  return (
    <Card
      elevation={8}
      sx={{ marginLeft: 1, marginRight: 3, borderRadius: 3, width: '300px' }}
    >
      <CardMedia>
        <DocumentFilePreview
          file={file}
          containerProps={{ height: 240 }}
          disableClickInteraction={true}
        />
      </CardMedia>
      <CardActionArea>
        <CardContent>
          <Typography variant={'h5'}>{file.name}</Typography>
          <Typography variant={'body2'}>
            By: {file.createdBy.fullName}
          </Typography>
          <Typography variant={'body2'}>
            Date: {file.createdAt.toDateString()}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default React.memo(DocumentCard)
